import React from 'react';
import './index.scss';
import { SUMMARY_TEXT } from '../../constants';
import SVGIcons from '../../../../../../../../Components/SVGIcons';


const SummaryHeader = (props) => {
    // Nothing to sum up until a list has reported; ComparisonView's loader
    // covers that first stretch on its own.
    if (!props.hasCounts) return null;

    return (
        <div className='trend-summary'>
            <span className='trend-summary__matched'>
                <strong>{props.matchedCount}</strong> {SUMMARY_TEXT.matched}
            </span>

            {/* Everyone matched leaves nothing to warn about, so the amber
                segment drops out rather than showing a zero. */}
            {props.notComparedCount > 0 && (
                <>
                    <span className='trend-summary__separator'>·</span>
                    <span className='trend-summary__not-compared'>
                        <SVGIcons type={"SVG-warning-triangle"} />
                        {props.notComparedCount} {SUMMARY_TEXT.notCompared}
                    </span>
                </>
            )}

            <span className='trend-summary__separator'>·</span>
            <span className='trend-summary__mode'>
                {SUMMARY_TEXT.against} {props.matchModeLabel}
            </span>
        </div>
    );
};

export default SummaryHeader;
